import React from "react";
import _ from "lodash";
import Select from "react-select";
import moment from "moment-timezone";

import UnitsSelector from "../../../common/UnitsSelector";
import CustomSetTargetingControlV2 from "../../../control-center/auto-pilot/config/CustomSetTargetingControlV2";
import TargetingWithInExControl from "../custom-upr/TargetingWithInExControl";
import PriceSettingsSection from "./PriceSettingsSection";
import NetworkPlacementModal from "../custom-upr/NetworkPlacementModal";
import VirtualPlacementSelector from "components/common/VirtualPlacementSelector";
import {
  buttonActionClassGray,
  buttonModalConfirmClass,
  buttonModalConfirmDisable,
} from "helpers/StyleClass";

import RadioControl from "components/common/RadioControl";

import { MODAL_TYPE, TYPE } from "./Constants";

const inputClass =
  "bg-white flex w-full border border-gray-400 rounded py-1 px-3 appearance-none leading-normal focus:outline-none focus:border-blue-400 focus:shadow-inner hover:border-gray-500";
const inputClassDisabled =
  "bg-gray-300 flex w-full border border-gray-400 rounded py-1 px-3 appearance-none leading-normal";

const targetingBlockClass = "border p-2 my-2 bg-white";
const targetingTitleClass = "block text-gray-800 font-bold mb-1"; //"font-semibold";

// Important! not snake case!!!!!!! snake case is in apconfig
const TARGETING_TYPE = {
  OS: "os",
  DC: "deviceCategory",
  COUNTRY: "country",
  BROWSER: "browser",
  CUSTOMS: "customs",
  INVENTORY_TYPES: "inventoryTypes",
  INVENTORY_URL: "inventoryUrl",
  INVENTORY_SIZE: "inventorySize",
  VIDEO_POSITIONS: "videoPositions",
  INVENTORY_FORMAT: "inventoryFormat",
  MOBILE_APPLICATION: "mobileApplication",
};

class NetworkCustomFirstLookForm extends React.Component {
  constructor(props) {
    super(props);

    const {
      ruleSetting,
      importRules,
      autoImport,
      rules,
      ruleCount,
      currentIdx,
      modalType,
    } = props;

    let id = "";
    if (importRules[0]) id = _.toNumber(importRules[0].externalId);
    else if (!_.isNil(ruleSetting.id)) id = ruleSetting.id;

    const {
      label = "",
      description = "",
      enabled = true,
      name = "",
      type = TYPE.DISPLAY,
      priceSection = {},
      targetingSection = {},
    } = importRules[0] || ruleSetting;

    const placementIdsString = _.get(
      targetingSection,
      ["inventory", "placementIds"],
      []
    ).join(",");

    const temp = {};
    _.forEach(importRules, (rule) => {
      const parsedRule = this._parseRule(rule);

      temp[rule.externalId] = {
        ...parsedRule,
        id: _.toNumber(rule.externalId),
        targetingSection: this._addAutoImport(
          parsedRule.targetingSection,
          autoImport
        ),
      };
    });

    this.state = {
      id,
      label,
      description,
      enabled,
      name,
      type,
      priceSection,
      targetingSection,
      placementIdsString,

      ruleOption: rules.map((rule) => ({
        label: `${rule.externalId} - ${rule.name}`,
        value: rule.externalId,
      })),

      importOption: importRules.map((rule) => ({
        label: `${rule.externalId} - ${rule.name}`,
        value: rule.externalId,
      })),

      previousOpt: null,
      selectedOpt: null,
      importedOpt: null,

      isOpenPlacementModal: false,

      tempDataObject: temp,
      priority: [MODAL_TYPE.ADD, MODAL_TYPE.COPY].includes(modalType)
        ? ruleCount + 1
        : currentIdx,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleTargetingSectionChanged =
      this.handleTargetingSectionChanged.bind(this);
    this.handleTargetingChanged = this.handleTargetingChanged.bind(this);
    this.handlePlacementIdsChanged = this.handlePlacementIdsChanged.bind(this);
    this.handlePlacementSelect = this.handlePlacementSelect.bind(this);
    this.handlePriceSettingsChanged =
      this.handlePriceSettingsChanged.bind(this);

    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleImport = this.handleImport.bind(this);
    this.handleImportChange = this.handleImportChange.bind(this);
    this.handlePriorityChange = this.handlePriorityChange.bind(this);
  }

  componentDidMount() {
    const { importOption, priority } = this.state;
    if (this.props.modalType === MODAL_TYPE.ADD) {
      if (importOption.length > 0) {
        this.handleImportChange(importOption[0]);
      } else {
        this.setState(
          {
            targetingSection: this._addAutoImport(
              this.state.targetingSection,
              this.props.autoImport
            ),
          },
          () => {
            this.handleUpdate("targetingSection", this.state.targetingSection);
          }
        );
      }
    }

    if (this.props.handlePriorityChange)
      this.props.handlePriorityChange(priority - 1);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.ruleCount !== this.props.ruleCount) {
      this.handlePriorityChange({ value: this.props.ruleCount + 1 });
    }
  }

  handleChange(value, key) {
    this.setState({
      [key]: value,
    });

    this.handleUpdate(key, value === "" ? undefined : value);
  }

  handleTargetingSectionChanged(value, path) {
    const targetingSection = _.cloneDeep(this.state.targetingSection);
    _.set(targetingSection, path, value);
    this.setState({ targetingSection });

    this.handleUpdate("targetingSection", targetingSection);
  }

  handlePlacementIdsChanged(e) {
    let idsString = e.target.value.replace(/\s+/g, "").split(",");
    idsString = _.uniq(_.compact(idsString));

    this.setState({
      placementIdsString: e.target.value,
    });

    this.handleTargetingSectionChanged(idsString, [
      "inventory",
      "placementIds",
    ]);
  }

  handlePlacementSelect(ids) {
    const placementIds = _.uniq(ids);

    this.setState({
      placementIdsString: placementIds.join(","),
      isOpenPlacementModal: false,
    });

    this.handleTargetingSectionChanged(placementIds, [
      "inventory",
      "placementIds",
    ]);
  }

  handleTargetingChanged(targeting, key) {
    let { targetingSection } = this.state;
    targetingSection[key] = targeting;
    if (!targeting) {
      targetingSection = _.omit(targetingSection, key);
    }

    this.setState({
      targetingSection,
    });

    this.handleUpdate("targetingSection", targetingSection);
  }

  handlePriceSettingsChanged(settings) {
    let { priceSection } = this.state;

    let newPriceSection = { ...priceSection };
    newPriceSection.priceSettings = settings;
    if (_.isEmpty(newPriceSection.priceSettings)) {
      newPriceSection = _.omit(newPriceSection, "priceSettings");
    }

    this.setState({
      priceSection: newPriceSection,
    });

    this.handleUpdate("priceSection", newPriceSection);
  }

  handleUpdate(key, value) {
    const { handleCurrentRuleChanged, ruleSetting } = this.props;

    if (handleCurrentRuleChanged) {
      handleCurrentRuleChanged({ ...ruleSetting, [key]: value });
    }
  }

  handleImport() {
    const { rules, autoImport } = this.props;
    const { selectedOpt, id } = this.state;
    const selectedRule = rules.find((r) => r.externalId === selectedOpt.value);

    const parsedRule = this._parseRule(selectedRule);
    const newRule = {
      ...parsedRule,
      id,
      targetingSection: this._addAutoImport(
        parsedRule.targetingSection,
        autoImport
      ),
    };

    this.setState({
      ...newRule,
      description: "",
      previousOpt: selectedOpt,
    });

    const { handleCurrentRuleChanged } = this.props;

    if (handleCurrentRuleChanged) {
      const rule = {
        ..._.omit(newRule, ["placementIdsString"]),
      };
      handleCurrentRuleChanged(rule);
    }
  }

  handleImportChange(opt) {
    const {
      id,
      name,
      type,
      label,
      description,
      enabled,
      priceSection,
      targetingSection,
      placementIdsString,
      tempDataObject,
      importedOpt,
    } = this.state;

    const importedRule = {
      id,
      name,
      type,
      label: _.isEmpty(label) ? undefined : label,
      description: _.isEmpty(description) ? undefined : description,
      enabled,
      priceSection,
      targetingSection,
      placementIdsString,
    };

    const dataObject = importedOpt
      ? {
          ...tempDataObject,
          [importedOpt.value]: importedRule,
        }
      : tempDataObject;
    const currentRule = dataObject[opt.value];

    this.setState(
      {
        tempDataObject: dataObject,
        ...currentRule,
        label: currentRule.label || "",
        description: currentRule.description || "",
        importedOpt: opt,
      },
      () => {
        const { handleCurrentRuleChanged, handleImportIdChanged } = this.props;

        if (handleCurrentRuleChanged) {
          const rule = {
            ..._.omit(currentRule, ["placementIdsString", "priority"]),
          };
          handleCurrentRuleChanged(rule);
        }

        if (handleImportIdChanged) {
          handleImportIdChanged(opt.value);
        }
      }
    );
  }

  handlePriorityChange({ value }) {
    const newVal = _.toNumber(value);
    this.setState({ priority: newVal });
    if (this.props.handlePriorityChange)
      this.props.handlePriorityChange(newVal - 1);
  }

  // Ref function
  handleSaveRule() {
    const { importOption, importedOpt } = this.state;

    if (!importedOpt) return;

    this.setState(
      {
        importOption: importOption.filter(
          (opt) => opt.value !== importedOpt.value
        ),
        importedOpt: null,
      },
      () => {
        const { importOption } = this.state;
        if (importOption.length > 0) {
          this.handleImportChange(importOption[0]);
        }
      }
    );

    return importOption.length > 1;
  }

  _parseRule(rule) {
    let setting = _.get(rule, "priceSection.priceSettings", []);
    setting = _.orderBy(setting, ["isSetForEverything"], ["asc"]);

    return {
      name: `${rule.name} (imported at ${moment().format(
        "YYYY-MM-DD HH:mm:ss Z"
      )})`,
      type: rule.type,
      enabled: true,
      label: "Imported",
      priceSection:
        setting.length > 0
          ? {
              priceSettings: setting,
            }
          : {},
      targetingSection: rule.targetingSection || {},
      placementIdsString: _.get(
        rule.targetingSection,
        ["inventory", "placementIds"],
        []
      ).join(","),
    };
  }

  _addAutoImport(targetingSection, importData) {
    if (_.isNil(importData)) return _.cloneDeep(targetingSection);
    if (_.isNil(targetingSection)) return {};

    const config = _.cloneDeep(targetingSection);
    if (importData) {
      const customs = _.get(config, ["customs"], []);
      if (customs.length === 0) {
        customs.push([importData]);
      } else {
        _.forEach(customs, (list) => {
          const checkOpt = _.findIndex(
            list,
            (d) => d.keyId === importData.keyId
          );
          if (checkOpt < 0) {
            list.push(importData);
          }
        });
      }

      _.set(config, ["customs"], customs);

      // Handle virtualPlacementIds add -2
      const virtualPlacementIds = _.get(
        config,
        ["inventory", "virtualPlacementIds"],
        []
      );
      _.set(
        config,
        ["inventory", "virtualPlacementIds"],
        _.uniq([...virtualPlacementIds, -2])
      );
    }

    return config;
  }

  render() {
    const {
      networkId,
      networkInfo,
      currency,
      modalType,
      placements,
      importRules,
      importIdList,
      ruleCount,
    } = this.props;

    const {
      enabled,
      id,
      name,
      type,
      label,
      description,
      priceSection,
      targetingSection,
      placementIdsString,
      priority,

      ruleOption,
      importOption,
      previousOpt,
      selectedOpt,
      importedOpt,

      isOpenPlacementModal,
    } = this.state;

    const priorityOption = _.range(
      1,
      ruleCount +
        ([MODAL_TYPE.ADD, MODAL_TYPE.COPY].includes(modalType) ? 2 : 1)
    ).map((count) => ({
      value: count,
      label: count,
    }));

    const priorityOpt = _.find(priorityOption, (opt) => opt.value === priority);

    return (
      <div>
        <div className="rounded mb-4 bg-white px-8 pb-8 pt-6">
          {importIdList.length > 0 && (
            <div className="rounded mb-4 flex items-center gap-2 bg-blue-100 p-4">
              <label className="block font-bold text-gray-800" htmlFor="ruleId">
                Import from External Rule ID ({importRules.length})
              </label>
              {importRules.length > 0 && (
                <Select
                  className="w-1/4"
                  value={importedOpt}
                  onChange={this.handleImportChange}
                  options={importOption}
                />
              )}
              {importIdList.length > importRules.length && (
                <div className="text-orange-600">
                  {importIdList.length - importRules.length} rule(s) not found.
                  {_.filter(
                    importIdList,
                    (id) => !importRules.find((r) => r.id === id)
                  ).join(", ")}
                </div>
              )}
            </div>
          )}
          {[MODAL_TYPE.ADD, MODAL_TYPE.COPY].includes(modalType) &&
            importRules.length === 0 && (
              <div className="rounded mb-4 flex items-center gap-2 bg-blue-100 p-4">
                <div className="flex items-center gap-2">
                  <label
                    className="block font-bold text-gray-800"
                    htmlFor="ruleId"
                  >
                    Import from External Rule
                  </label>
                  <Select
                    className="w-64"
                    value={selectedOpt}
                    onChange={(val) => {
                      this.setState({
                        previousOpt: selectedOpt,
                        selectedOpt: val,
                      });
                    }}
                    options={ruleOption}
                  />
                  <button
                    type="button"
                    className={
                      !_.isEqual(previousOpt, selectedOpt)
                        ? buttonModalConfirmClass
                        : buttonModalConfirmDisable
                    }
                    onClick={this.handleImport}
                    disabled={_.isEqual(previousOpt, selectedOpt)}
                  >
                    Import
                  </button>
                </div>
              </div>
            )}

          {enabled !== false && (
            <div className="my-4">
              <div className="flex w-1/4 items-center justify-between">
                <label
                  className="block font-bold text-gray-800"
                  htmlFor="priority"
                >
                  Priority
                </label>
                <div className="text-sm font-semibold text-gray-600">
                  {ruleCount} items in {type} type
                </div>
              </div>

              <Select
                className="w-1/4"
                value={priorityOpt}
                onChange={this.handlePriorityChange}
                options={priorityOption}
              />
            </div>
          )}

          <div className="mb-4">
            <label className="block font-bold text-gray-800" htmlFor="ruleId">
              ID
            </label>
            <input
              className={
                [MODAL_TYPE.ADD, MODAL_TYPE.COPY].includes(modalType)
                  ? inputClass
                  : inputClassDisabled
              }
              id="ruleId"
              value={id || ""}
              onChange={(e) =>
                this.handleChange(_.toNumber(e.target.value), "id")
              }
              disabled={modalType === MODAL_TYPE.EDIT}
            />
          </div>

          <div className="mb-4">
            <label className="block font-bold text-gray-800" htmlFor="name">
              Name
            </label>
            <input
              className={inputClass}
              id="name"
              type="text"
              value={name}
              onChange={(e) => this.handleChange(e.target.value, "name")}
            />
          </div>

          <div className="mb-4">
            <label className="block font-bold text-gray-800" htmlFor="label">
              Label (optional)
            </label>
            <input
              className={inputClass}
              id="label"
              type="text"
              value={label}
              onChange={(e) => this.handleChange(e.target.value, "label")}
            />
          </div>

          <div className="mb-4">
            <label
              className="block font-bold text-gray-800"
              htmlFor="description"
            >
              Description (optional)
            </label>
            <input
              className={inputClass}
              id="description"
              type="text"
              value={description}
              onChange={(e) => this.handleChange(e.target.value, "description")}
            />
          </div>

          <div className="mb-4">
            <label className="block font-bold text-gray-800">Type</label>
            <RadioControl
              options={_.values(TYPE).map((d) => ({
                value: d,
                label: _.startCase(d),
                disabled: modalType === MODAL_TYPE.EDIT,
              }))}
              value={type}
              onChange={(value) => this.handleChange(value, "type")}
            ></RadioControl>
          </div>

          <div
            className="border-t rounded mb-4 bg-gray-300 px-4 py-2"
            key={`pricing-${id}`}
          >
            <div className="border-b mb-2 mt-2 text-lg font-bold">
              Price Settings
            </div>
            <div>
              <PriceSettingsSection
                networkId={networkInfo.networkId}
                currency={currency}
                priceSettings={priceSection.priceSettings}
                handlePriceSettingsChanged={this.handlePriceSettingsChanged}
                handleIsEditing={this.props.handleIsEditing}
              ></PriceSettingsSection>
            </div>
          </div>

          <div
            className="border-t rounded mb-4 bg-gray-300 px-4 py-2"
            key={`targeting-${id}`}
          >
            <div className="border-b mt-2 text-lg font-bold">Targeting</div>
            <div className={targetingBlockClass}>
              <div className={targetingTitleClass}>Inventory</div>
              <div>
                Unit IDs:{" "}
                <span className="text-sm text-gray-700">
                  (you can also paste a list of "," separated <i>unitIds</i> or{" "}
                  <i>extGamUnitIds</i>)
                </span>
              </div>
              <UnitsSelector
                networkId={networkId}
                handleChanged={(val) => {
                  this.handleTargetingSectionChanged(val, [
                    "inventory",
                    "unitIds",
                  ]);
                }}
                isCreatable={true}
                selectedItems={_.get(
                  targetingSection,
                  ["inventory", "unitIds"],
                  []
                )}
              ></UnitsSelector>
              <div className="text-xs text-gray-600">
                {(targetingSection.inventory &&
                  targetingSection.inventory.unitIds &&
                  targetingSection.inventory.unitIds.length) ||
                  0}{" "}
                unitIds
              </div>

              <div className="mt-2">
                Exclude Unit IDs:{" "}
                <span className="text-sm text-gray-700">
                  (you can also paste a list of "," separated <i>unitIds</i> or{" "}
                  <i>extGamUnitIds</i>)
                </span>
              </div>
              <UnitsSelector
                networkId={networkId}
                handleChanged={(val) => {
                  this.handleTargetingSectionChanged(val, [
                    "inventory",
                    "excludedUnitIds",
                  ]);
                }}
                isCreatable={true}
                selectedItems={_.get(
                  targetingSection,
                  ["inventory", "excludedUnitIds"],
                  []
                )}
              ></UnitsSelector>
              <div className="text-xs text-gray-600">
                Excluding{" "}
                {
                  _.get(targetingSection, ["inventory", "excludedUnitIds"], [])
                    .length
                }{" "}
                unitIds
              </div>

              <div className="mt-2 flex items-center justify-between">
                <div>Placement IDs: ("," separated)</div>
                <button
                  type="button"
                  className={buttonActionClassGray}
                  onClick={() => {
                    this.setState({ isOpenPlacementModal: true });
                  }}
                >
                  Select from Resource Mapping
                </button>
              </div>
              <textarea
                className={inputClass}
                id="placementIds"
                rows="1"
                value={placementIdsString}
                onChange={this.handlePlacementIdsChanged}
              ></textarea>
              {_.get(targetingSection, ["inventory", "placementIds"], [])
                .length > 0 && (
                <div
                  className="flex flex-wrap gap-1 overflow-y-auto bg-gray-200 p-2"
                  style={{ maxHeight: "200px" }}
                >
                  {(targetingSection.inventory.placementIds || []).map((id) => {
                    const item = placements.find((p) => p.id === id);
                    return (
                      <div
                        key={id}
                        className={`border rounded border-gray-400 px-1 text-sm ${
                          item ? "bg-blue-200" : "bg-red-200"
                        }`}
                      >
                        {id} {item ? item.props.type : "UNKNOWN"}
                      </div>
                    );
                  })}
                </div>
              )}
              <div className="flex items-center gap-1 text-xs text-gray-600">
                <div>
                  {
                    _.get(targetingSection, ["inventory", "placementIds"], [])
                      .length
                  }{" "}
                  placements
                </div>
              </div>

              <div className="mt-2">
                Virtual Placement IDs:{" "}
                <span className="text-sm text-gray-700">
                  (you can also paste a list of "," separated{" "}
                  <i>virtualPlacementIds</i>)
                </span>
              </div>
              <VirtualPlacementSelector
                networkId={networkId}
                handleChanged={(val) => {
                  this.handleTargetingSectionChanged(val, [
                    "inventory",
                    "virtualPlacementIds",
                  ]);
                }}
                selectedItems={_.get(
                  targetingSection,
                  ["inventory", "virtualPlacementIds"],
                  []
                )}
              ></VirtualPlacementSelector>
              <div className="text-xs text-gray-600">
                {
                  _.get(
                    targetingSection,
                    ["inventory", "virtualPlacementIds"],
                    []
                  ).length
                }{" "}
                virtualPlacementIds
              </div>
            </div>

            <div className={targetingBlockClass}>
              <div className={targetingTitleClass}>OS</div>
              <TargetingWithInExControl
                targetingType={TARGETING_TYPE.OS}
                targeting={targetingSection[TARGETING_TYPE.OS]}
                handleTargetingChanged={(t) =>
                  this.handleTargetingChanged(t, TARGETING_TYPE.OS)
                }
              ></TargetingWithInExControl>
            </div>

            <div className={targetingBlockClass}>
              <div className={targetingTitleClass}>Device Category</div>

              <TargetingWithInExControl
                targetingType={TARGETING_TYPE.DC}
                targeting={targetingSection[TARGETING_TYPE.DC]}
                handleTargetingChanged={(t) =>
                  this.handleTargetingChanged(t, TARGETING_TYPE.DC)
                }
              ></TargetingWithInExControl>
            </div>

            <div className={targetingBlockClass}>
              <div className={targetingTitleClass}>Country</div>
              <TargetingWithInExControl
                targetingType={TARGETING_TYPE.COUNTRY}
                targeting={targetingSection[TARGETING_TYPE.COUNTRY]}
                handleTargetingChanged={(t) =>
                  this.handleTargetingChanged(t, TARGETING_TYPE.COUNTRY)
                }
              ></TargetingWithInExControl>
            </div>

            <div className={targetingBlockClass}>
              <div className={targetingTitleClass}>Mobile Application</div>
              <TargetingWithInExControl
                networkId={networkId}
                targetingType={TARGETING_TYPE.MOBILE_APPLICATION}
                targeting={targetingSection[TARGETING_TYPE.MOBILE_APPLICATION]}
                handleTargetingChanged={(t) =>
                  this.handleTargetingChanged(
                    t,
                    TARGETING_TYPE.MOBILE_APPLICATION
                  )
                }
              ></TargetingWithInExControl>
            </div>

            <div className={targetingBlockClass}>
              <div className={targetingTitleClass}>Inventory URL</div>
              <TargetingWithInExControl
                networkId={networkId}
                targetingType={TARGETING_TYPE.INVENTORY_URL}
                targeting={targetingSection[TARGETING_TYPE.INVENTORY_URL]}
                handleTargetingChanged={(t) =>
                  this.handleTargetingChanged(t, TARGETING_TYPE.INVENTORY_URL)
                }
              ></TargetingWithInExControl>
            </div>

            <div className={targetingBlockClass}>
              <div className={targetingTitleClass}>Inventory Size</div>
              <TargetingWithInExControl
                networkId={networkId}
                targetingType={TARGETING_TYPE.INVENTORY_SIZE}
                targeting={targetingSection[TARGETING_TYPE.INVENTORY_SIZE]}
                handleTargetingChanged={(t) =>
                  this.handleTargetingChanged(t, TARGETING_TYPE.INVENTORY_SIZE)
                }
              ></TargetingWithInExControl>
            </div>

            <div className={targetingBlockClass}>
              <div className={targetingTitleClass}>
                Customs (
                {targetingSection[TARGETING_TYPE.CUSTOMS]
                  ? targetingSection[TARGETING_TYPE.CUSTOMS].length
                  : 0}
                )
              </div>
              <div className="bg-gray-200 p-2">
                <CustomSetTargetingControlV2
                  networkId={networkId}
                  handleIsEditing={this.props.handleIsEditing}
                  targeting={targetingSection[TARGETING_TYPE.CUSTOMS]}
                  handleValueChanged={(t) =>
                    this.handleTargetingChanged(t, TARGETING_TYPE.CUSTOMS)
                  }
                ></CustomSetTargetingControlV2>
              </div>
            </div>
          </div>

          {isOpenPlacementModal && (
            <NetworkPlacementModal
              selected={
                (targetingSection.inventory &&
                  targetingSection.inventory.placementIds) ||
                []
              }
              placements={placements}
              handleClose={() => {
                this.setState({ isOpenPlacementModal: false });
              }}
              handleConfirm={this.handlePlacementSelect}
            ></NetworkPlacementModal>
          )}
        </div>
      </div>
    );
  }
}

export default NetworkCustomFirstLookForm;
